import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OrdonnanceService } from 'src/app/service/ordonnance.service';
import { ToastrService } from 'ngx-toastr';
import { OrdonnanceDto } from 'src/app/DTO/ordonnance.dto';
import { EnumEtats } from 'src/app/enum/enum.etat';

@Component({
  selector: 'app-ordonnance-etat',
  templateUrl: './ordonnance-etat.component.html',
  styleUrls: ['./ordonnance-etat.component.scss']
})
export class OrdonnanceEtatComponent implements OnInit {

  @Input()
  sendFormEvent: Observable<void>;
  private sendFormEventSubscription: Subscription;

  @Input()
  public message: string = "";
  public copyMail = false;

  @Input()
  private ordonnance: OrdonnanceDto;

  @Input()
  private etat: string;

  @Input()
  private etatCode: number;

  @Output()
  private formSended: EventEmitter<boolean> = new EventEmitter();

  public ordonnanceMessageForm: FormGroup;
  public submitted = false;

  protected displayError = false;

  constructor(
    private formBuilder: FormBuilder,
    protected ordonnanceService: OrdonnanceService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.ordonnanceMessageForm = this.formBuilder.group({
      message: this.formBuilder.control(this.message, [Validators.required]),
      copyMail: this.formBuilder.control(this.copyMail),
    });

    this.sendFormEventSubscription = this.sendFormEvent.subscribe(() => this.onSubmit());
  }

  ngOnDestroy() {
    this.sendFormEventSubscription.unsubscribe();
  }

  /**
   * convenience getter for easy access to form fields
   */
  get field() {
    return this.ordonnanceMessageForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.ordonnanceMessageForm.invalid) {
      return;
    }
    if (this.etat === EnumEtats.TRAITEE) {
      this.ordonnanceService.putOrdonnanceProcessed(this.ordonnance.id, this.ordonnanceMessageForm.value.message, this.copyMail).subscribe(
        data => { this.toastr.success("L'ordonnance a été déclarée comme étant traitée. Un mail a été envoyé au bénéficiaire."); },
        err => { this.toastr.error("Une erreur est survenue. Merci de réessayer plus tard."); },
        () => { this.formSended.emit(true); }
      );
    } else if (this.etat === EnumEtats.REJETEE) {
      this.ordonnanceService.putOrdonnanceRejetee(this.ordonnance.id, this.ordonnanceMessageForm.value.message, this.copyMail, this.etatCode).subscribe(
        data => { this.toastr.success("L'ordonnance a été rejetée. Un mail a été envoyé au bénéficiaire."); },
        err => { this.toastr.error("Une erreur est survenue. Merci de réessayer plus tard."); },
        () => { this.formSended.emit(true); }
      );
    } else if (this.etat === EnumEtats.ENCOURS) {
      this.ordonnanceService.putOrdonnanceInformation(this.ordonnance.id, this.ordonnanceMessageForm.value.message, this.copyMail).subscribe(
        data => { this.toastr.success("La demande a bien été enregistrée. Un mail a été envoyé au bénéficiaire."); },
        err => { this.toastr.error("Une erreur est survenue. Merci de réessayer plus tard."); },
        () => { this.formSended.emit(true); }
      );
    }
  }

}
